module.exports = __webpack_public_path__ + "static/media/carousel_banner_4.92a6f34a.png";